import Dexie from 'dexie'
import { IEntry } from '@/types/entry'
import Entry from './entry-model'

class VoltStore extends Dexie {
    entries!: Dexie.Table<IEntry, string>

    constructor(prefix: string = 'global') {
        super(`volt-store:${prefix}`)
        if (process.env.NODE_ENV === 'test') return
        this.version(1).stores({
            entries: '&entryId, schemaType, title, parentId, sortOrder, *tags, createdBy, createdAt, updatedAt, viewedAt',
            peers: '&userId, email'
        })
        this.entries.mapToClass(Entry)
    }
}

export const DBStore = new VoltStore()
